import { render } from "./TitleSingleSeason.vue?vue&type=template&id=60411bba"
import script from "./TitleSingleSeason.vue?vue&type=script&lang=js"
export * from "./TitleSingleSeason.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__